import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {
    getConcluidosPorData, getEnviadosPorData,
    getEstacoesTrabalho, getListaCabecalhoOSRecapados, getPneusNaCasa,
    getRecebidosPorData, getRecusadosReprovadosPorData, getSaldos
} from "../../../actions/i4Actions";
import ProducaoMensalView from "./ProducaoMensalView";
import {getTempoEtapas} from "../../../actions/orderActions";
import {getSOTiresStatistics} from "../../../actions/serviceOrderStatistics";


const useStyles = makeStyles(theme => ({
    mainGrid:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'

    },

    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const today = new Date();

const PainelTVProducaoMensal = ( props ) => {
    const classes = useStyles();

    const periodMin = useSelector( state => state.filter.periodMin );
    const periodMax = useSelector( state => state.filter.periodMax );
    const dispatch = useDispatch();


    const refreshData = () => {
        dispatch(getSaldos());
        dispatch(getPneusNaCasa());
        dispatch(getEstacoesTrabalho());
        dispatch(getRecebidosPorData());
        dispatch(getEnviadosPorData());
        dispatch(getConcluidosPorData());
        dispatch(getRecusadosReprovadosPorData());
        dispatch(getTempoEtapas());
        dispatch(getSOTiresStatistics())
        dispatch(getListaCabecalhoOSRecapados())

        const dtIniIni = periodMin.substr(0,10) === (new Date(today.getFullYear(), today.getMonth(), 1)).toISOString().substr(0,10);
        const dtFimHoje = periodMax.substr(0,10) === (new Date().toISOString().substr(0,10));

        if (dtIniIni && dtFimHoje) {
            props.setTitulo("PRODUÇÃO - MÊS")
        } else{
            props.setTitulo("PRODUÇÃO - PERIODO")
        }
    }

    // useEffect( () => {
    //
    //     refreshData();
    // }, [periodMin]);
    //
    // useEffect( () => {
    //
    //     refreshData();
    // }, [periodMax]);


    useEffect( () => {
        console.log("producao mes bandas useEffect props.contador", props.contador);
        refreshData();
    }, [props.contador]);

    useEffect( () => {
        console.log("producao mes bandas useEffect props.tcContador", props.tcContador);
        refreshData();
    }, [props.tcContador]);

    return (
        <React.Fragment>
               <ProducaoMensalView/>
        </React.Fragment>
    )

}
export default (PainelTVProducaoMensal);


